import { render, staticRenderFns } from "./importActivityTemplateDialog.vue?vue&type=template&id=0dd867ac&scoped=true"
import script from "./importActivityTemplateDialog.vue?vue&type=script&lang=ts"
export * from "./importActivityTemplateDialog.vue?vue&type=script&lang=ts"
import style0 from "./importActivityTemplateDialog.vue?vue&type=style&index=0&id=0dd867ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd867ac",
  null
  
)

export default component.exports